import script from "./LearningSpaceFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSpaceFrame.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSpaceFrame.vue?vue&type=style&index=0&id=62f46e26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f46e26"]])

export default __exports__